import React, { useContext } from 'react';
import { ApolloClient, gql, ApolloConsumer } from '@apollo/client';
import AnalysListQuery from '../../../../../../../Queries/EkonomiskAnalysListQuery/AnalysListQuery.gql';
import { KodplanConsumer } from '../../../../../../../../../../../../Components/KodplanManager/Context/KodplanContext';
import { ActiveDatabaseContext } from '../../../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

interface IProps {
  children: (mutateFn: SaveFavoriteAnalysFnType) => React.ReactNode;
}
interface IInnerProps extends IProps {
  apolloClient: ApolloClient<any>;
  activeKodplanId: string | undefined;
  activeDatabase: string | null;
}

export type SaveFavoriteAnalysFnType = (
  changedAnalys: IChangedAnalysInfo[],
  callback?: () => void
) => void;

export interface IChangedAnalysInfo {
  kodBehId: string;
  analysId: string;
  favoritLopnr: number | null;
  utdelatLopnr: number | null;
  saveForUserId?: string;
}

const getMutation = (changedAnalyser: IChangedAnalysInfo[]) => {
  let mutationField = '';
  changedAnalyser.forEach((analys, index) => {
    mutationField += 'mut' + index + ':ekanalys_setfavorit(';
    mutationField += ' favorit_lopnr:' + analys.favoritLopnr;
    mutationField += ' utdelning_lopnr:' + analys.utdelatLopnr;
    mutationField += ' analys_id:' + `"${analys.analysId}"`;
    mutationField += ' kodbeh_id:' + `"${analys.kodBehId}"`;
    mutationField += ' favorit:' + String(analys.favoritLopnr === null);
    if (analys.saveForUserId) {
      mutationField += ' saveForUserId:' + `"${analys.saveForUserId}"`;
    }

    mutationField += '){';
    mutationField += 'favorit_lopnr';
    mutationField += ' analys_id';
    mutationField += ' kodbeh_id';
    mutationField += ' utdelning_lopnr';
    mutationField += '}';
  });

  return gql`
        mutation UpdateFavoriteAnalyser {
            ${mutationField}
        }
    `;
};

class ChangeAnalysFavoriteMutationBase extends React.Component<IInnerProps> {
  changeFavorites = (
    changedAnalyser: IChangedAnalysInfo[],
    callback?: () => void
  ) => {
    if (changedAnalyser.length === 0) {
      return;
    }

    this.props.apolloClient
      .mutate({
        mutation: getMutation(changedAnalyser),
        refetchQueries: result => {
          const codeplanID = this.props.activeKodplanId;
          if (result && result.data && result.errors == null && codeplanID) {
            return [
              {
                query: AnalysListQuery,
                variables: {
                  codeSystemId: codeplanID,
                  onlyFavorites: false,
                  dbName: this.props.activeDatabase ?? '',
                },
              },
            ];
          } else {
            return [];
          }
        },
      })
      .then(() => {
        if (callback) {
          callback();
        }
      });
  };

  render() {
    return <>{this.props.children(this.changeFavorites)}</>;
  }
}

const ChangeAnalysFavoriteMutation: React.FunctionComponent<IProps> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);

  return (
    <ApolloConsumer>
      {client => (
        <KodplanConsumer>
          {({ activeKodplan }) => (
            <ChangeAnalysFavoriteMutationBase
              apolloClient={client}
              activeKodplanId={activeKodplan?.id}
              activeDatabase={activeDatabase}
              {...props}
            />
          )}
        </KodplanConsumer>
      )}
    </ApolloConsumer>
  );
};

export default ChangeAnalysFavoriteMutation;
